import React, { FormEvent, useEffect, useMemo, useState } from "react";

// Utils
import { Form, FormGroup, Radio, CheckboxProps, FormField, Dropdown } from "semantic-ui-react";

// Common
import DateTextBox from "react-lib/apps/common/DateTextBox";
import ButtonLoadCheck from "react-lib/appcon/common/ButtonLoadCheck";
import { useIntl } from "react-intl";

const CardDoctorFeeByPaymentFilter = (props: any) => {
  const intl = useIntl();
  
  // useState
  const [requiredStartDate, setRequiredStartDate] = useState<boolean>(false);
  const [requiredEndDate, setRequiredEndDate] = useState<boolean>(false);
  const [requiredDoctor, setRequiredDoctor] = useState<boolean>(false);

  useEffect(() => {
    const doctor = props.sequence?.doctorFeeByPaymentReport?.doctor;
    setRequiredDoctor(!doctor);
  }, [props.sequence?.doctorFeeByPaymentReport?.doctor]);

  const doctorOptions = useMemo(() => {
    return [
      // { key: "ALL", value: "ALL", text: "แพทย์ทั้งหมด" }, //* ยังไม่มั่นใจว่าใช้หรือไม่
      ...(props.masterOptions?.doctor || []),
    ];
  }, [props.masterOptions?.doctor]);

  const handleSelectRadio = (optionSelected: any) => {
    if (["daily", "monthly", "yearly"].includes(optionSelected)) {
      return props.sequence?.doctorFeeByPaymentReport?.reportType === `${optionSelected}`;
    }

    console.warn("Option Doesn't Exist!!");
    return;
  };

  const handleChangeRadio = (e: FormEvent<HTMLInputElement>, data: CheckboxProps) => {
    if (typeof data.value === "string") {
      props.setProp(`${props.sequenceName}.doctorFeeByPaymentReport.reportType`, data.value);
    }
  };

  const handleDownloadButton = () => {
    if (requiredStartDate || requiredEndDate) {
      alert("กรุณาระบุข้อมูลให้ครบถ้วน");
    } else {
      props.runSequence({
        sequence: props.runSequenceName,
        action: "DOWNLOAD_REPORT",
        menu: "รายงานค่าตอบแทนแพทย์ตามวันที่รับชำระ",
        isClinic: props.isClinic,
      });
    }
  };

  return (
    <Form>
      <FormGroup style={{ gap: "1rem", padding: "0rem 0rem 0rem 1rem" }}>
        <label style={{ display: "flex", alignItems: "center" }}>{intl.formatMessage({ id: "ประเภทรายงาน" })}</label>
        <Radio
          label={intl.formatMessage({ id: "ประจำวัน" })}
          checked={handleSelectRadio("daily")}
          onChange={handleChangeRadio}
          value="daily"
          style={{ display: "flex", alignItems: "center" }}
        />
        <Radio
          label={intl.formatMessage({ id: "ประจำเดือน" })}
          checked={handleSelectRadio("monthly")}
          onChange={handleChangeRadio}
          value="monthly"
          style={{ display: "flex", alignItems: "center" }}
        />
        <Radio
          label={intl.formatMessage({ id: "ประจำปี" })}
          checked={handleSelectRadio("yearly")}
          onChange={handleChangeRadio}
          value="yearly"
          style={{ display: "flex", alignItems: "center" }}
        />
      </FormGroup>
      <FormGroup inline style={{ display: "flex", justifyContent: "space-between", padding: "0rem 0rem 0rem 0.5rem" }}>
        <FormField inline style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
          <label>
            วันที่รับชำระ<span style={{ color: "red" }}>*</span>
          </label>
          <DateTextBox
            onChange={(date: string) => {
              props.setProp(
                `${props.sequenceName}.doctorFeeByPaymentReport.filterStartDate`,
                date
              )
              if (props.sequence?.doctorFeeByPaymentReport?.filterStartDate.length < 1) {
                setRequiredStartDate(true);
              } else {
                setRequiredStartDate(false);
              }
            }}
            // style={{ width: "3rem" }}
            value={props.sequence?.doctorFeeByPaymentReport?.filterStartDate || ""}
          />
          <label>{intl.formatMessage({ id: "ถึง" })}</label>
          <DateTextBox
            onChange={(date: string) => {
              props.setProp(
                `${props.sequenceName}.doctorFeeByPaymentReport.filterEndDate`,
                date
              )
              if (props.sequence?.doctorFeeByPaymentReport?.filterEndDate.length < 1) {
                setRequiredEndDate(true);
              } else {
                setRequiredEndDate(false);
              }
            }}
            // style={{ width: "3rem" }}
            value={props.sequence?.doctorFeeByPaymentReport?.filterEndDate || ""}
          />
        </FormField>
        <FormField inline>
          <ButtonLoadCheck
            setProp={props.setProp}
            onClick={handleDownloadButton}
            paramKey={`${props.cardKeyButton}_${props.buttonAction}`}
            buttonLoadCheck={props.buttonLoadCheck?.[`${props.cardKeyButton}_${props.buttonAction}`]}
            color="green"
            style={{ width: "11rem" }}
            title={intl.formatMessage({ id: "ดาวน์โหลด xlsx" })}
          />
        </FormField>
      </FormGroup>
      {["ClinicAnnualReportSequence"].includes(props.sequenceName) && (
        <FormGroup inline style={{ gap: "1rem", padding: "0rem 0rem 0rem 0.5rem" }}>
          <FormField inline>
            <label 
              style={{
                display: "flex",
                alignItems: "center",
                padding: "0rem 0.8rem 0rem 0rem",
              }}
            >
              ชื่อแพทย์ <span style={{ color: "red" }}>*</span>
            </label>
          </FormField>
          <FormField inline>
            <Dropdown
              value={props.sequence?.doctorFeeByPaymentReport?.doctor || ""}
              onChange={(e: any, data: any) => 
                props.setProp(
                  `${props.sequenceName}.doctorFeeByPaymentReport.doctor`,
                  data.value
                )
              }
              placeholder={intl.formatMessage({ id: "เลือกแพทย์" })}
              options={doctorOptions}
              search
              selection
              style={{ minWidth: "20rem" }}
            />
          </FormField>
        </FormGroup>
      )}
    </Form>
  )
};

export default CardDoctorFeeByPaymentFilter;